import { HubConnection, IStreamResult } from "@microsoft/signalr"

export type UnregisterHandler = () => void;
export const ApiHash: string = "92134bc0d849ef5d96ba3cb5ba6da047";

export class MultigameSlotServerHub {
    constructor(protected connection: HubConnection) {
    }




    interfaceVersion(): Promise<string> {
        return this.connection.invoke("InterfaceVersion");
    }

    restartBackend(): Promise<void> {
        return this.connection.invoke("RestartBackend");
    }

    loadGames(gamePageRequest: PageRequest): Promise<PageResponseOfIGameConfiguration> {
        return this.connection.invoke("LoadGames", gamePageRequest);
    }

    loadSettings(): Promise<SettingsNode> {
        return this.connection.invoke("LoadSettings");
    }

    loadInfo(frontendInfo: FrontendInfo): Promise<LoadInfo> {
        return this.connection.invoke("LoadInfo", frontendInfo);
    }

    frontendError(errorCode: FrontendErrorCode, message: string): Promise<void> {
        return this.connection.invoke("FrontendError", errorCode, message);
    }

    frontendLoadingProgress(progress: string): Promise<void> {
        return this.connection.invoke("FrontendLoadingProgress", progress);
    }

    frontendResources(page: FrontendResourcesPage): Promise<void> {
        return this.connection.invoke("FrontendResources", page);
    }

    frontendLoadingComplete(): Promise<LoadFinishedInfo> {
        return this.connection.invoke("FrontendLoadingComplete");
    }

    frontendLoadingError(missingResources: ResourceItem[]): Promise<void> {
        return this.connection.invoke("FrontendLoadingError", missingResources);
    }

    ping(): Promise<void> {
        return this.connection.invoke("Ping");
    }

    keyboard(key: string, pressed: boolean): Promise<void> {
        return this.connection.invoke("Keyboard", key, pressed);
    }

    gameSelect(gameName: string): Promise<boolean> {
        return this.connection.invoke("GameSelect", gameName);
    }

    slot_Spin(gameName: string, betRequest: BetRequest): Promise<SpinSuccess> {
        return this.connection.invoke("Slot_Spin", gameName, betRequest);
    }

    gameFinished(): Promise<void> {
        return this.connection.invoke("GameFinished");
    }

    getUnfinishedGame(): Promise<UnfinishedSuccess> {
        return this.connection.invoke("GetUnfinishedGame");
    }

    getLastGame(gameIndex: number): Promise<UnfinishedSuccess> {
        return this.connection.invoke("GetLastGame", gameIndex);
    }

    betChanged(betIndex: number): Promise<boolean> {
        return this.connection.invoke("BetChanged", betIndex);
    }

    payout(): Promise<void> {
        return this.connection.invoke("Payout");
    }

    setCallAttendant(callingAttendant: boolean, reason: string): Promise<void> {
        return this.connection.invoke("SetCallAttendant", callingAttendant, reason);
    }

    canCollect(p: CanCollectParams): Promise<void> {
        return this.connection.invoke("CanCollect", p);
    }

    jpShowStart(p: JpShowParams): Promise<void> {
        return this.connection.invoke("JpShowStart", p);
    }

    gameExit(): Promise<void> {
        return this.connection.invoke("GameExit");
    }

    menuEntered(key: string): Promise<void> {
        return this.connection.invoke("MenuEntered", key);
    }

    menuExited(): Promise<void> {
        return this.connection.invoke("MenuExited");
    }

    menuRamClear(): Promise<RamClearResult> {
        return this.connection.invoke("MenuRamClear");
    }

    getPendingHandpays(): Promise<HandpayData[]> {
        return this.connection.invoke("GetPendingHandpays");
    }

    cashierHandpayConfirm(): Promise<boolean> {
        return this.connection.invoke("CashierHandpayConfirm");
    }

    setIOSerial(serialNumber: string): Promise<void> {
        return this.connection.invoke("SetIOSerial", serialNumber);
    }

    getGameSettings(): Promise<MultigameConfig> {
        return this.connection.invoke("GetGameSettings");
    }

    saveGameSettings(config: MultigameConfig): Promise<void> {
        return this.connection.invoke("SaveGameSettings", config);
    }

    keys(): Promise<Key[]> {
        return this.connection.invoke("Keys");
    }

    saveKeys(newKeys: Key[]): Promise<void> {
        return this.connection.invoke("SaveKeys", newKeys);
    }

    insertCredit(insertedcredit: number): Promise<void> {
        return this.connection.invoke("insertCredit", insertedcredit);
    }

    removePartialCredit(valueCents: number): Promise<void> {
        return this.connection.invoke("removePartialCredit", valueCents);
    }

    removeCredit(): Promise<void> {
        return this.connection.invoke("removeCredit");
    }

    eventInfo(pageIndex: number): Promise<EventPage> {
        return this.connection.invoke("EventInfo", pageIndex);
    }

    saveHardwareConfig(hardwareType: HardwareType, hardwareName: string, settings: HardwareSettingsBaseValue[]): Promise<Result> {
        return this.connection.invoke("SaveHardwareConfig", hardwareType, hardwareName, settings);
    }

    getHardwareConfig(): Promise<HardwareConfigCollection> {
        return this.connection.invoke("GetHardwareConfig");
    }

    doubleUp_Start(winAmountInCents?: number): Promise<IDoubleUpAction> {
        return this.connection.invoke("DoubleUp_Start", winAmountInCents);
    }

    doubleUp_Pick(cardColor: CardColor): Promise<IDoubleUpAction> {
        return this.connection.invoke("DoubleUp_Pick", cardColor);
    }

    doubleUp_CollectHalf(): Promise<IDoubleUpAction> {
        return this.connection.invoke("DoubleUp_CollectHalf");
    }

    doubleUp_CollectAll(): Promise<IDoubleUpAction> {
        return this.connection.invoke("DoubleUp_CollectAll");
    }

    doubleUp_End(): Promise<IDoubleUpAction> {
        return this.connection.invoke("DoubleUp_End");
    }

    getOutOfService(): Promise<boolean> {
        return this.connection.invoke("GetOutOfService");
    }

    setOutOfService(outOfService: boolean): Promise<void> {
        return this.connection.invoke("SetOutOfService", outOfService);
    }

    getRealMeters(gameName: string): Promise<MetersReport> {
        return this.connection.invoke("GetRealMeters", gameName);
    }

    getTempMeters(gameName: string): Promise<MetersReport> {
        return this.connection.invoke("GetTempMeters", gameName);
    }

    clearTempMeters(): Promise<void> {
        return this.connection.invoke("ClearTempMeters");
    }

    getSettings(): Promise<SettingsNode> {
        return this.connection.invoke("GetSettings");
    }

    setSettings(path: string, value: string): Promise<SetSettingsResult> {
        return this.connection.invoke("SetSettings", path, value);
    }

    systemInfo(): Promise<SystemInfo> {
        return this.connection.invoke("SystemInfo");
    }

    restart(): Promise<void> {
        return this.connection.invoke("Restart");
    }

    getLinkLicenceStatus(): Promise<LinkLicenceStatus> {
        return this.connection.invoke("GetLinkLicenceStatus");
    }

    confirmLinkLicence(confirmCode: string): Promise<boolean> {
        return this.connection.invoke("ConfirmLinkLicence", confirmCode);
    }

    getTimeLicenceStatus(): Promise<TimeLicenceStatus> {
        return this.connection.invoke("GetTimeLicenceStatus");
    }

    confirmTimeLicence(confirmCode: string): Promise<boolean> {
        return this.connection.invoke("ConfirmTimeLicence", confirmCode);
    }

    getHistoryGame(pageIndex: number): Promise<HistoryGamePage> {
        return this.connection.invoke("GetHistoryGame", pageIndex);
    }

    outputsChanged(outputStates: OutputState[]): Promise<void> {
        return this.connection.invoke("OutputsChanged", outputStates);
    }

    sendScreenLeds(message: string): Promise<void> {
        return this.connection.invoke("SendScreenLeds", message);
    }

    saveIOMapping(iomapping: IOMapping): Promise<void> {
        return this.connection.invoke("SaveIOMapping", iomapping);
    }

    getIOMappings(): Promise<IOMappingFile[]> {
        return this.connection.invoke("GetIOMappings");
    }

    loadIOMapping(iomappingFile: IOMappingFile): Promise<IOMapping> {
        return this.connection.invoke("LoadIOMapping", iomappingFile);
    }

    deleteIOMapping(iomappingFile: IOMappingFile): Promise<IOMappingFile[]> {
        return this.connection.invoke("DeleteIOMapping", iomappingFile);
    }

    jackpothitRequest(hitRequest: PublicJackpotHitRequest): Promise<void> {
        return this.connection.invoke("JackpothitRequest", hitRequest);
    }

    storageSetOne(key: string, value: string): Promise<void> {
        return this.connection.invoke("StorageSetOne", key, value);
    }

    storageSetMany(values: { [key: string]: string; }): Promise<void> {
        return this.connection.invoke("StorageSetMany", values);
    }

    storageGetOne(key: string): Promise<string> {
        return this.connection.invoke("StorageGetOne", key);
    }

    storageGetMany(keys: string[]): Promise<{ [key: string]: string; }> {
        return this.connection.invoke("StorageGetMany", keys);
    }

    storageGetAll(): Promise<{ [key: string]: string; }> {
        return this.connection.invoke("StorageGetAll");
    }

    storageDeleteOne(key: string): Promise<void> {
        return this.connection.invoke("StorageDeleteOne", key);
    }

    storageDeleteMany(keys: string[]): Promise<void> {
        return this.connection.invoke("StorageDeleteMany", keys);
    }


    protected operationHandlers: Map<string, any> = new Map<string, any>();
    public registerOperation<T extends MultigameSlotServerOperationName>(operation: T, handlerName: string, handler: MultigameSlotServerOperationHandler<T>): UnregisterHandler {
        let operationHandlerName = `${operation}=>${handlerName}`;

        if (this.operationHandlers.has(operationHandlerName))
        {
            throw `Handler ${handlerName} for operation ${operation} already set`;
        }

        let safeSignalRHandler = (...args: any[]) =>
        {
            try
            {
                (handler as any).apply(null, args);
            }
            catch (ex)
            {
                console.error("Error in signalR handler", ex);
            }
        }

        this.operationHandlers.set(operationHandlerName, safeSignalRHandler);
        this.connection.on(operation, safeSignalRHandler);

        let unregisterHandler = () => {
            this.unregisterOperation(operation, handlerName);
        };
        
        return unregisterHandler;
    }

    public unregisterOperation<T extends MultigameSlotServerOperationName>(operation: T, handlerName: string) {
        let operationHandlerName = `${operation}=>${handlerName}`;
        let handler = this.operationHandlers.get(operationHandlerName)
        if (handler)
        {
            this.operationHandlers.delete(operationHandlerName);
            this.connection.off(operation, handler);
        }
    }
}

export interface MultigameSlotServerHandlers {
    "MachineLock": (p: MachineLockedParams) => void;
    "MachineUnlock": () => void;
    "IOSetupChanged": (p: IOSetup) => void;
    "IOConnectionChanged": (connected: boolean, message: string) => void;
    "HandpayPending": (p: HandpayPendingParams) => void;
    "HandpayReset": () => void;
    "CashIn": (p: CashInParams) => void;
    "CashOut": (p: CashOutParams) => void;
    "SharedJackpotUpdate": (sharedJackpotGameState: SharedJackpotGameState) => void;
    "JackpotValuesUpdate": (p: JackpotValuesUpdateParams) => void;
    "StopAutoplay": () => void;
    "RamClearComplete": (result: RamClearResult) => void;
    "CanCollect": (p: CanCollectParams) => void;
    "LinkLicence": (p: LinkLicenceParams) => void;
    "TimeLicence": (p: TimeLicenceParams) => void;
    "GameMenu": () => void;
    "GameSelected": (gameName: string) => void;
    "KeyAppiled": (key: Key) => void;
    "Keys": (keys: Key[]) => void;
    "MenuEnter": (key: Key) => void;
    "MenuExit": () => void;
    "MenuEnterDenied": (code: string, reason: string) => void;
    "OutOfServiceChanged": (outOfService: boolean) => void;
    "GameClearComplete": () => void;
    "InputChanged": (inputStates: InputState[]) => void;
    "RobotStart": (enabled: boolean) => void;
    "CallAttendantChanged": (callingAttendant: boolean) => void;
    "TouchTestStart": (timeoutSeconds: number) => void;
    "TouchTestStop": () => void;
    "SetAudioLevel": (level: number) => void;
    "SharedJackpotWin": (win: SharedJackpotWin) => void;
}

export type MultigameSlotServerOperationName = keyof MultigameSlotServerHandlers;
export type MultigameSlotServerOperationHandler<T extends MultigameSlotServerOperationName> = MultigameSlotServerHandlers[T];

export interface ISimpleBonusCommonConfiguration {
}

export interface IFeatureConfiguration {
    FeatureType: string | undefined;
    FeatureName: string | undefined;
}

export interface IFeatureResult {
    FeatureName: string | undefined;
    FeatureTriggered: boolean;
    Count: number;
}

export interface IFeaturePublicType {
}

export interface ISimpleBonusAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export enum SimpleBonusPhase {
    Start = "Start",
    Run = "Run",
    Spin = "Spin",
    Pick = "Pick",
    End = "End",
}

export interface SimpleSlotGameWinAmounts {
    PaytableWin: Money | undefined;
    SequentialProgressiveNonProgressiveWins: ProgressiveWin[] | undefined;
    TotalWin: Money | undefined;
}

export interface Money {
    InCents: number;
}

export interface ProgressiveWin {
    Level: JackpotLevel;
    ProgressiveIndex: number;
    ProgressiveType: ProgressiveType;
    Win: Money | undefined;
    ExceedsWinLimit: boolean;
    WinTimeUTC: Date;
}

export enum JackpotLevel {
    Jp4 = "jp4",
    Jp4s = "jp4s",
    Jp3 = "jp3",
    Jp3s = "jp3s",
    Jp2 = "jp2",
    Jp1 = "jp1",
}

export enum ProgressiveType {
    Progressive = "Progressive",
    NonProgressive = "NonProgressive",
}

export interface ISimpleBonusPickAction {
}

export interface ISimpleBonusStartAction {
}

export interface ISimpleBonusEndAction {
}

export interface ISimpleBonusSpinAction {
    SpinWithFeatures: SlotGameSpin | undefined;
    Win: SlotGameWin | undefined;
    Triggers: SimpleTriggerResult[] | undefined;
}

export interface SlotGameSpin {
    ReelStops: number[] | undefined;
    Bet: SlotGameBet | undefined;
    FeatureResults: { [key: string]: IFeatureResult; } | undefined;
    ExpectedSymbols: string[][] | undefined;
    ReelRowExpectedSymbols: string[][] | undefined;
}

export interface SlotGameBet {
    Denom: Money | undefined;
    Lines: number;
    TotalBetCredits: number;
    TotalBetCents: Money | undefined;
    BuyBonusCredits: number | undefined;
    BuyBonusMultiplier: number | undefined;
    BuyBonusCents: Money | undefined;
}

export interface SlotGameWin {
    TotalWin: Money | undefined;
    ResultLines: LineWin[] | undefined;
    ScaterWin: Money | undefined;
}

export interface LineWin {
    LineIndex: number;
    SymbolIndex: number;
    SymbolID: string | undefined;
    SymbolCount: number;
    Hit: boolean;
    Win: Money | undefined;
    WildCount: number;
}

export interface SimpleTriggerResult {
    symbolsTriggered: SymbolPosition[] | undefined;
    Bonus: string | undefined;
    WillTrigger: boolean;
    Anticipation: number;
    Count: number;
    Hint: SimplePublicTriggerHint | undefined;
}

export interface SymbolPosition {
    Reel: number;
    Row: number;
}

export interface SimplePublicTriggerHint {
    Multiplier: number | undefined;
    LevelPercent: number;
}

export interface IGameConfiguration {
    GameType: GameType;
    GameName: string | undefined;
    GameIndex: number;
    Order: number;
}

export enum GameType {
    Slot = "Slot",
    DoubleUp = "DoubleUp",
}

export interface HardwareSettingsBaseValue {
    Name: string | undefined;
    Value: string | undefined;
}

export interface CurrencyOption {
    Name: string | undefined;
    Short: string | undefined;
    Prefix: string | undefined;
    Suffix: string | undefined;
    DecimalSeparator: string | undefined;
    ThousandsSeparator: string | undefined;
}

export interface DoubleUpGameState {
    GameName: string | undefined;
    ParentGameName: string | undefined;
    BetStart: Money | undefined;
    Denom: Money | undefined;
    CreditStart: Money | undefined;
    TotalBet: Money | undefined;
    TotalWin: Money | undefined;
    CreditEnd: Money | undefined;
    GameSequence: string | undefined;
    Actions: IDoubleUpAction[] | undefined;
}

export interface IDoubleUpAction {
    Action: string | undefined;
    PickSequence: number;
    Bet: Money | undefined;
    Collected: Money | undefined;
    TotalBet: Money | undefined;
    Credit: Money | undefined;
    CreditEnd: Money | undefined;
    ForceGameEnd: boolean;
    History: Card[];
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export enum Card {
    C2 = "C2",
    C3 = "C3",
    C4 = "C4",
    C5 = "C5",
    C6 = "C6",
    C7 = "C7",
    C8 = "C8",
    C9 = "C9",
    C10 = "C10",
    CJ = "CJ",
    CK = "CK",
    CQ = "CQ",
    CA = "CA",
    D2 = "D2",
    D3 = "D3",
    D4 = "D4",
    D5 = "D5",
    D6 = "D6",
    D7 = "D7",
    D8 = "D8",
    D9 = "D9",
    D10 = "D10",
    DJ = "DJ",
    DK = "DK",
    DQ = "DQ",
    DA = "DA",
    H2 = "H2",
    H3 = "H3",
    H4 = "H4",
    H5 = "H5",
    H6 = "H6",
    H7 = "H7",
    H8 = "H8",
    H9 = "H9",
    H10 = "H10",
    HJ = "HJ",
    HK = "HK",
    HQ = "HQ",
    HA = "HA",
    S2 = "S2",
    S3 = "S3",
    S4 = "S4",
    S5 = "S5",
    S6 = "S6",
    S7 = "S7",
    S8 = "S8",
    S9 = "S9",
    S10 = "S10",
    SJ = "SJ",
    SK = "SK",
    SQ = "SQ",
    SA = "SA",
}

export enum SpeedType {
    Type1 = "Type1",
    Type2 = "Type2",
    Type3 = "Type3",
}

export enum CelebrationType {
    Fast = "Fast",
    Normal = "Normal",
    Slow = "Slow",
}

export interface IPaytableData {
    Type: string | undefined;
    Template: string | undefined;
    PaytableForBetCredits: number;
}

export interface SharedJackpotGameState {
    GameName: string | undefined;
    GameSequence: string | undefined;
    RealGameName: string | undefined;
    JackpotLevel: JackpotLevel;
    WinAmount: Money | undefined;
    BetCents: Money | undefined;
    BetDenom: Money | undefined;
    CreditStart: Money | undefined;
    CreditEnd: Money | undefined;
    TotalBetCents: Money | undefined;
    TotalJackpotAmount: Money | undefined;
    GameStartData: GameStartData | undefined;
    GameEndData: GameEndData | undefined;
    CanCollect: boolean;
}

export interface GameStartData {
    GameName: string | undefined;
    GameSequence: string | undefined;
    Denom: SASDenom | undefined;
    Bet: Money | undefined;
    Paid: Money | undefined;
    MaxBet: Money | undefined;
}

export interface SASDenom {
    code: number;
    cents: number;
    Code: number;
    Cents: number;
    DisplayValue: string | undefined;
}

export interface GameEndData {
    GameName: string | undefined;
    GameIndex: number;
    GameSequence: string | undefined;
    Denom: SASDenom | undefined;
    ReelPosition: number;
    PaytableWin: Money | undefined;
    PaytableWinLimitExceeded: boolean;
    ProgressiveWins: ProgressiveWin[] | undefined;
    NonProgressiveWins: ProgressiveWin[] | undefined;
    TotalWin: Money | undefined;
}

export interface PageRequest {
    Page: number;
    PageSize: number;
}

export interface PageResponseOfIGameConfiguration {
    Total: number;
    Page: number;
    PageSize: number;
    Data: IGameConfiguration[] | undefined;
}

export interface SettingsNode {
    ID: string | undefined;
    Name: string | undefined;
    Type: string | undefined;
}

export interface FrontendInfo {
    FrontendVersion: string | undefined;
    ApiHash: string | undefined;
}

export interface LoadInfo {
    ApiHash: string | undefined;
    Balance: Money | undefined;
    IOSetup: IOSetup | undefined;
}

export interface IOSetup {
    IOMapping: IOMapping | undefined;
    BoardParams: IBoardInitParams | undefined;
}

export interface IOMapping {
    Name: string | undefined;
    InputMap: InputMap[] | undefined;
    OutputMap: OutputMap[] | undefined;
}

export interface InputMap {
    Pin: number;
    Func: InputFunction;
    Type: InputType;
    Polarity: InputPolarity;
    DebounceMillis: number;
}

export enum InputFunction {
    Unmapped = "Unmapped",
    ButtonPayout = "ButtonPayout",
    ButtonSpin = "ButtonSpin",
    ButtonAutoplay = "ButtonAutoplay",
    ButtonMaxBet = "ButtonMaxBet",
    ButtonGamesMenu = "ButtonGamesMenu",
    ButtonCallAttendant = "ButtonCallAttendant",
    ButtonHelp = "ButtonHelp",
    ButtonBet1 = "ButtonBet1",
    ButtonBet2 = "ButtonBet2",
    ButtonBet3 = "ButtonBet3",
    ButtonBet4 = "ButtonBet4",
    ButtonBet5 = "ButtonBet5",
    ButtonBetUp = "ButtonBetUp",
    ButtonBetDown = "ButtonBetDown",
    ButtonBetNext = "ButtonBetNext",
    ButtonLinesNext = "ButtonLinesNext",
    ButtonDoubleUp = "ButtonDoubleUp",
    ButtonDoubleUpRed = "ButtonDoubleUpRed",
    ButtonDoubleUpBlack = "ButtonDoubleUpBlack",
    ButtonDoubleUpCollectHalf = "ButtonDoubleUpCollectHalf",
    ButtonDoubleUpCollectAll = "ButtonDoubleUpCollectAll",
    ButtonVolumeNext = "ButtonVolumeNext",
    ButtonDenomMenu = "ButtonDenomMenu",
    ButtonCreditsMoney = "ButtonCreditsMoney",
    ButtonBuyBonus = "ButtonBuyBonus",
    ButtonSettings = "ButtonSettings",
    DoorSlot = "DoorSlot",
    DoorDrop = "DoorDrop",
    DoorCardCage = "DoorCardCage",
    DoorCashbox = "DoorCashbox",
    DoorBelly = "DoorBelly",
    LockAttendant = "LockAttendant",
    LockOperator = "LockOperator",
}

export enum InputType {
    Unmapped = "Unmapped",
    Button = "Button",
    Door = "Door",
    Lock = "Lock",
}

export enum InputPolarity {
    Normal = "Normal",
    Reversed = "Reversed",
}

export interface OutputMap {
    Pin: number;
    Func: OutputFunction;
    Type: OutputType;
    Polarity: OutputPolarity;
}

export enum OutputFunction {
    Unmapped = "Unmapped",
    LightButtonPayout = "LightButtonPayout",
    LightButtonSpin = "LightButtonSpin",
    LightButtonAutoplay = "LightButtonAutoplay",
    LightButtonMaxBet = "LightButtonMaxBet",
    LightButtonGamesMenu = "LightButtonGamesMenu",
    LightButtonCallAttendant = "LightButtonCallAttendant",
    LightButtonHelp = "LightButtonHelp",
    LightButtonBet1 = "LightButtonBet1",
    LightButtonBet2 = "LightButtonBet2",
    LightButtonBet3 = "LightButtonBet3",
    LightButtonBet4 = "LightButtonBet4",
    LightButtonBet5 = "LightButtonBet5",
    LightButtonBetUp = "LightButtonBetUp",
    LightButtonBetDown = "LightButtonBetDown",
    LightButtonBetNext = "LightButtonBetNext",
    LightButtonLinesNext = "LightButtonLinesNext",
    LightButtonDoubleUp = "LightButtonDoubleUp",
    LightButtonDoubleUpRed = "LightButtonDoubleUpRed",
    LightButtonDoubleUpBlack = "LightButtonDoubleUpBlack",
    LightButtonDoubleUpCollectHalf = "LightButtonDoubleUpCollectHalf",
    LightButtonDoubleUpCollectAll = "LightButtonDoubleUpCollectAll",
    LightButtonVolumeNext = "LightButtonVolumeNext",
    LightButtonDenomMenu = "LightButtonDenomMenu",
    LightButtonCreditsMoney = "LightButtonCreditsMoney",
    LightButtonSettings = "LightButtonSettings",
    LightButtonBuyBonus = "LightButtonBuyBonus",
    LightCallAttendant = "LightCallAttendant",
    LightMachineProblem = "LightMachineProblem",
    LightPowerOn = "LightPowerOn",
}

export enum OutputType {
    Unmapped = "Unmapped",
    LightButton = "LightButton",
    LightOther = "LightOther",
}

export enum OutputPolarity {
    Normal = "Normal",
    Reversed = "Reversed",
}

export interface IBoardInitParams {
    Name: string | undefined;
    Platform: string | undefined;
    FirmwareVersion: string | undefined;
    SerialNumber: string | undefined;
    NumInputs: number;
    NumOutputs: number;
}

export enum FrontendErrorCode {
    UnknownFrontendError = "UnknownFrontendError",
    CriticalFrontendError = "CriticalFrontendError",
    WebGLContextLost = "WebGLContextLost",
    WebGLContextRecovering = "WebGLContextRecovering",
    WebGLDestroy = "WebGLDestroy",
    WebGLDestroySuccess = "WebGLDestroySuccess",
    WebGLDestroyError = "WebGLDestroyError",
    WebGLCreate = "WebGLCreate",
    WebGLCreateSuccess = "WebGLCreateSuccess",
    WebGLCreateError = "WebGLCreateError",
    WebGLContextRecovered = "WebGLContextRecovered",
    WebGLUnknownError = "WebGLUnknownError",
    WebGLNotSupported = "WebGLNotSupported",
    WebGLRecoverError = "WebGLRecoverError",
    WebGLRecoverFail = "WebGLRecoverFail",
    GameReplay = "GameReplay",
    FrontendSpinError = "FrontendSpinError",
    FrontendApiNotCompatible = "FrontendApiNotCompatible",
    TouchPressingAlone = "TouchPressingAlone",
    TouchPressingOk = "TouchPressingOk",
    JackpotDisplayError = "JackpotDisplayError",
    JackpotDisplayOk = "JackpotDisplayOk",
}

export interface FrontendResourcesPage {
    Offset: number;
    Total: number;
    BasePath: string | undefined;
    Resources: FrontendResource[] | undefined;
}

export interface FrontendResource {
    Type: string | undefined;
    Name: string | undefined;
    Paths: string[] | undefined;
    FrameWidth: number | undefined;
    FrameHeight: number | undefined;
}

export interface LoadFinishedInfo {
    Balance: Money | undefined;
}

export interface ResourceItem {
    Name: string | undefined;
    Path: string | undefined;
}

export interface BetRequest {
    Index: number;
    Type: BetType;
}

export enum BetType {
    Normal = "Normal",
    BuyBonus = "BuyBonus",
}

export interface SpinSuccess {
    Success: boolean;
    Message: string | undefined;
    Balance: Money | undefined;
    GameState: SimpleSlotGameState | undefined;
}

export interface SimpleSlotGameState {
    GameName: string | undefined;
    GameSeq: string | undefined;
    CreditStart: Money | undefined;
    CreditEnd: Money | undefined;
    Bet: BetPlayed | undefined;
    Paid: Money | undefined;
    TotalJackpotIncrement: number | undefined;
    FreeRoundsNumber: number | undefined;
    PlayedFreeRoundsNumber: number | undefined;
    FreeRoundsBet: Money | undefined;
    TotalWin: SimpleSlotGameWinAmounts | undefined;
    Actions: ISimpleBonusAction[] | undefined;
    WasBonus: boolean;
    WasHandpay: boolean;
    GameStartData: GameStartData | undefined;
    GameEndData: GameEndData | undefined;
    CanCollect: boolean;
}

export interface BetPlayed {
    Bet: SlotGameBet | undefined;
    BetType: BetType;
}

export interface UnfinishedSuccess {
    Success: boolean;
    Message: string | undefined;
    GameState: string | undefined;
}

export interface CanCollectParams {
    CanCollect: boolean;
    TotalWin: Money | undefined;
    CurrentCreditTotal: Money | undefined;
}

export interface JpShowParams {
    jackpotName: string | undefined;
    duration: number;
    win: number;
}

export interface RamClearResult {
    Success: boolean;
    ErrorMessage: string | undefined;
}

export interface HandpayData {
    HandpayReason: HandpayReason;
    GameName: string | undefined;
    GameIndex: number;
    ProgressiveIndex: number;
    HandpayAmount: Money | undefined;
}

export enum HandpayReason {
    NoHandpay = "NoHandpay",
    PaytableWinLimit = "PaytableWinLimit",
    ProgressiveWinLimit = "ProgressiveWinLimit",
    NormalPayout = "NormalPayout",
    ManualPayout = "ManualPayout",
    CreditLimit = "CreditLimit",
    AftDenied = "AftDenied",
}

export interface MultigameConfig {
    GamesConfig: { [key: string]: GameConfig; } | undefined;
}

export interface GameConfig {
    GameId: number;
    Enabled: boolean;
    GameName: string | undefined;
    NewSticker: NewSticker;
    Order: number;
    EnabledVariant: GameVariant | undefined;
    AvailableVariants: { [key: string]: GameVariant; } | undefined;
}

export enum NewSticker {
    None = "None",
    NewGame = "NewGame",
    NewFeatures = "NewFeatures",
}

export interface GameVariant {
    File: string | undefined;
    BetConfig: BetConfig[] | undefined;
}

export interface BetConfig {
    Enabled: boolean;
    BuyBonusEnabled: boolean;
    Bet: SlotGameBet | undefined;
}

export interface Key {
    Code: string | undefined;
    Permissions: string[] | undefined;
}

export interface EventPage {
    Events: PublicEvent[] | undefined;
    NumOfPages: number;
    PageIndex: number;
}

export interface PublicEvent {
    EventCode: string | undefined;
    Details: string | undefined;
    Locks: boolean;
    Locked: boolean;
    EventId: number;
    Reported: boolean;
    TimeOfOccurrence: Date;
    TimeFormatted: string | undefined;
    TimestampMillis: number;
}

export enum HardwareType {
    BillAcceptor = "BillAcceptor",
    Printer = "Printer",
    IOBoard = "IOBoard",
    Jackpot = "Jackpot",
}

export interface Result {
    Ok: boolean;
    ErrorMessage: string | undefined;
}

export interface HardwareConfigCollection {
    AvailableHardware: { [key in keyof typeof HardwareType]?: { [key: string]: HardwareFactoryForOneType; }; };
    ConfiguredHardware: { [key in keyof typeof HardwareType]?: ConfiguredHardware; };
}

export interface HardwareFactoryForOneType {
    HardwareName: string;
    Options: HardwareSettingsValue[];
}

export interface HardwareSettingsValue extends HardwareSettingsBaseValue {
    Type: string | undefined;
    Description: string | undefined;
    DefaultValue: string | undefined;
}

export interface ConfiguredHardware {
    HardwareName: string;
    Options: HardwareSettingsBaseValue[];
}

export enum CardColor {
    Red = "Red",
    Black = "Black",
}

export interface MetersReport {
    RequestedMeters: string | undefined;
    Level: MeterLevel;
    LastReset: Date | undefined;
    LastResetFormatted: string | undefined;
    Meters: MeterSummary[] | undefined;
}

export enum MeterLevel {
    Real = "Real",
    Temp = "Temp",
    Session = "Session",
}

export interface MeterSummary {
    Code: string | undefined;
    MeterName: MeterName;
    Value: number;
    ValueType: MeterValueType;
    Name: string | undefined;
    AlternativeName: string | undefined;
    Description: string | undefined;
}

export enum MeterName {
    CREDITS_COIN_IN = "CREDITS_COIN_IN",
    CREDITS_COIN_OUT = "CREDITS_COIN_OUT",
    CREDITS_JACKPOT = "CREDITS_JACKPOT",
    CREDITS_HAND_PAID_CANCELLED = "CREDITS_HAND_PAID_CANCELLED",
    CREDITS_CANCELLED = "CREDITS_CANCELLED",
    GAMES_PLAYED = "GAMES_PLAYED",
    GAMES_WON = "GAMES_WON",
    GAMES_LOST = "GAMES_LOST",
    CREDITS_FROM_BILLS_ACCEPTED = "CREDITS_FROM_BILLS_ACCEPTED",
    CREDITS_CURRENT = "CREDITS_CURRENT",
    TICKET_CASHABLE_IN_INCLUDING_NONRESTRICTED_CENTS = "TICKET_CASHABLE_IN_INCLUDING_NONRESTRICTED_CENTS",
    TICKET_CASHABLE_OUT_INCLUDING_DEBIT_CENTS = "TICKET_CASHABLE_OUT_INCLUDING_DEBIT_CENTS",
    TICKET_RESTRICTED_IN_CENTS = "TICKET_RESTRICTED_IN_CENTS",
    TICKET_RESTRICTED_OUT_CENTS = "TICKET_RESTRICTED_OUT_CENTS",
    TICKET_CASHABLE_IN_INCLUDING_NONRESTRICTED_QUANTITY = "TICKET_CASHABLE_IN_INCLUDING_NONRESTRICTED_QUANTITY",
    TICKET_CASHABLE_OUT_INCLUDING_DEBIT_QUANTITY = "TICKET_CASHABLE_OUT_INCLUDING_DEBIT_QUANTITY",
    TICKET_RESTRICTED_IN_QUANTITY = "TICKET_RESTRICTED_IN_QUANTITY",
    TICKET_RESTRICTED_OUT_QUANTITY = "TICKET_RESTRICTED_OUT_QUANTITY",
    TICKET_IN = "TICKET_IN",
    TICKET_OUT = "TICKET_OUT",
    ELECTRONIC_TRANSFERS_TO_GAMING_MACHINE = "ELECTRONIC_TRANSFERS_TO_GAMING_MACHINE",
    ELECTRONIC_TRANSFERS_TO_HOST = "ELECTRONIC_TRANSFERS_TO_HOST",
    CREDITS_RESTRICTED_PLAYED = "CREDITS_RESTRICTED_PLAYED",
    CREDITS_NONRESTRICTED_PLAYED = "CREDITS_NONRESTRICTED_PLAYED",
    CREDITS_RESTRICTED_CURRENT = "CREDITS_RESTRICTED_CURRENT",
    WIN_PAYTABLE = "WIN_PAYTABLE",
    WIN_PROGRESSIVE = "WIN_PROGRESSIVE",
    WIN_EXTERNAL_BONUS = "WIN_EXTERNAL_BONUS",
    ATTENDANT_PAID_WIN_PAYTABLE = "ATTENDANT_PAID_WIN_PAYTABLE",
    ATTENDANT_PAID_WIN_PROGRESSIVE = "ATTENDANT_PAID_WIN_PROGRESSIVE",
    ATTENDANT_PAID_WIN_EXTERNAL_BONUS = "ATTENDANT_PAID_WIN_EXTERNAL_BONUS",
    CREDITS_WON = "CREDITS_WON",
    CREDITS_HAND_PAID = "CREDITS_HAND_PAID",
    CREDITS_DROP = "CREDITS_DROP",
    GAMES_SINCE_RESET = "GAMES_SINCE_RESET",
    GAMES_SINCE_SLOT_DOOR_CLOSURE = "GAMES_SINCE_SLOT_DOOR_CLOSURE",
    TICKET_CASHABLE_IN_CREDITS = "TICKET_CASHABLE_IN_CREDITS",
    TICKET_NONRESTRICTED_IN_CREDITS = "TICKET_NONRESTRICTED_IN_CREDITS",
    TICKET_CASHABLE_OUT_CREDITS = "TICKET_CASHABLE_OUT_CREDITS",
    ELECTRONIC_REGULAR_TO_GAMING_MACHINE = "ELECTRONIC_REGULAR_TO_GAMING_MACHINE",
    ELECTRONIC_RESTRICTED_TO_GAMING_MACHINE = "ELECTRONIC_RESTRICTED_TO_GAMING_MACHINE",
    ELECTRONIC_NONRESTRICTED_TO_GAMING_MACHINE = "ELECTRONIC_NONRESTRICTED_TO_GAMING_MACHINE",
    ELECTRONIC_REGULAR_TO_HOST = "ELECTRONIC_REGULAR_TO_HOST",
    ELECTRONIC_RESTRICTED_TO_HOST = "ELECTRONIC_RESTRICTED_TO_HOST",
    ELECTRONIC_NONRESTRICTED_TO_HOST = "ELECTRONIC_NONRESTRICTED_TO_HOST",
    TICKET_CASHABLE_IN_QUANTITY = "TICKET_CASHABLE_IN_QUANTITY",
    TICKET_NONRESTRICTED_IN_QUANTITY = "TICKET_NONRESTRICTED_IN_QUANTITY",
    TICKET_CASHABLE_OUT_QUANTITY = "TICKET_CASHABLE_OUT_QUANTITY",
    BILLS_STACKER_QUANTITY = "BILLS_STACKER_QUANTITY",
    BILLS_STACKER_VALUE = "BILLS_STACKER_VALUE",
    BILLS_ACCEPTED_1 = "BILLS_ACCEPTED_1",
    BILLS_ACCEPTED_2 = "BILLS_ACCEPTED_2",
    BILLS_ACCEPTED_5 = "BILLS_ACCEPTED_5",
    BILLS_ACCEPTED_10 = "BILLS_ACCEPTED_10",
    BILLS_ACCEPTED_20 = "BILLS_ACCEPTED_20",
    BILLS_ACCEPTED_25 = "BILLS_ACCEPTED_25",
    BILLS_ACCEPTED_50 = "BILLS_ACCEPTED_50",
    BILLS_ACCEPTED_100 = "BILLS_ACCEPTED_100",
    BILLS_ACCEPTED_200 = "BILLS_ACCEPTED_200",
    BILLS_ACCEPTED_250 = "BILLS_ACCEPTED_250",
    BILLS_ACCEPTED_500 = "BILLS_ACCEPTED_500",
    BILLS_ACCEPTED_1000 = "BILLS_ACCEPTED_1000",
    BILLS_ACCEPTED_2000 = "BILLS_ACCEPTED_2000",
    BILLS_ACCEPTED_2500 = "BILLS_ACCEPTED_2500",
    BILLS_ACCEPTED_5000 = "BILLS_ACCEPTED_5000",
    BILLS_ACCEPTED_10000 = "BILLS_ACCEPTED_10000",
    BILLS_ACCEPTED_20000 = "BILLS_ACCEPTED_20000",
    BILLS_ACCEPTED_25000 = "BILLS_ACCEPTED_25000",
    BILLS_ACCEPTED_50000 = "BILLS_ACCEPTED_50000",
    BILLS_ACCEPTED_100000 = "BILLS_ACCEPTED_100000",
    BILLS_ACCEPTED_200000 = "BILLS_ACCEPTED_200000",
    BILLS_ACCEPTED_250000 = "BILLS_ACCEPTED_250000",
    BILLS_ACCEPTED_500000 = "BILLS_ACCEPTED_500000",
    BILLS_ACCEPTED_1000000 = "BILLS_ACCEPTED_1000000",
    PAYBACK_PERCENTAGE = "PAYBACK_PERCENTAGE",
    TICKET_IN_CASHABLE_CENTS = "TICKET_IN_CASHABLE_CENTS",
    TICKET_IN_RESTRICTED_CENTS = "TICKET_IN_RESTRICTED_CENTS",
    TICKET_IN_RESTRICTED_QUANTITY = "TICKET_IN_RESTRICTED_QUANTITY",
    TICKET_IN_NONRESTRICTED_CENTS = "TICKET_IN_NONRESTRICTED_CENTS",
    TICKET_IN_NONRESTRICTED_QUANTITY = "TICKET_IN_NONRESTRICTED_QUANTITY",
    TICKET_OUT_CASHABLE_CENTS = "TICKET_OUT_CASHABLE_CENTS",
    TICKET_OUT_CASHABLE_QUANTITY = "TICKET_OUT_CASHABLE_QUANTITY",
    TICKET_OUT_RESTRICTED_CENTS = "TICKET_OUT_RESTRICTED_CENTS",
    TICKET_OUT_RESTRICTED_QUANTITY = "TICKET_OUT_RESTRICTED_QUANTITY",
    INHOUSE_TRANSFER_CASHABLE_TO_GAMING_MACHINE_CENTS = "INHOUSE_TRANSFER_CASHABLE_TO_GAMING_MACHINE_CENTS",
    INHOUSE_TRANSFER_CASHABLE_TO_GAMING_MACHINE_QUANTITY = "INHOUSE_TRANSFER_CASHABLE_TO_GAMING_MACHINE_QUANTITY",
    INHOUSE_TRANSFER_RESTRICTED_TO_GAMING_MACHINE_CENTS = "INHOUSE_TRANSFER_RESTRICTED_TO_GAMING_MACHINE_CENTS",
    INHOUSE_TRANSFER_RESTRICTED_TO_GAMING_MACHINE_QUANTITY = "INHOUSE_TRANSFER_RESTRICTED_TO_GAMING_MACHINE_QUANTITY",
    INHOUSE_TRANSFER_NONRESTRICTED_TO_GAMING_MACHINE_CENTS = "INHOUSE_TRANSFER_NONRESTRICTED_TO_GAMING_MACHINE_CENTS",
    INHOUSE_TRANSFER_NONRESTRICTED_TO_GAMING_MACHINE_QUANTITY = "INHOUSE_TRANSFER_NONRESTRICTED_TO_GAMING_MACHINE_QUANTITY",
    INHOUSE_TRANSFER_CASHABLE_TO_HOST_CENTS = "INHOUSE_TRANSFER_CASHABLE_TO_HOST_CENTS",
    INHOUSE_TRANSFER_CASHABLE_TO_HOST_QUANTITY = "INHOUSE_TRANSFER_CASHABLE_TO_HOST_QUANTITY",
    INHOUSE_TRANSFER_RESTRICTED_TO_HOST_CENTS = "INHOUSE_TRANSFER_RESTRICTED_TO_HOST_CENTS",
    INHOUSE_TRANSFER_RESTRICTED_TO_HOST_QUANTITY = "INHOUSE_TRANSFER_RESTRICTED_TO_HOST_QUANTITY",
    INHOUSE_TRANSFER_NONRESTRICTED_TO_HOST_CENTS = "INHOUSE_TRANSFER_NONRESTRICTED_TO_HOST_CENTS",
    INHOUSE_TRANSFER_NONRESTRICTED_TO_HOST_QUANTITY = "INHOUSE_TRANSFER_NONRESTRICTED_TO_HOST_QUANTITY",
    KEYED_ON_CASHABLE = "KEYED_ON_CASHABLE",
    CREDITS_NONRESTRICTED_CURRENT = "CREDITS_NONRESTRICTED_CURRENT",
    POWER_RESET = "POWER_RESET",
    SLOT_DOOR_OPEN = "SLOT_DOOR_OPEN",
    PROGRESSIVE_1_WIN_QUANTITY = "PROGRESSIVE_1_WIN_QUANTITY",
    PROGRESSIVE_1_WIN_AMOUNT = "PROGRESSIVE_1_WIN_AMOUNT",
    PROGRESSIVE_2_WIN_QUANTITY = "PROGRESSIVE_2_WIN_QUANTITY",
    PROGRESSIVE_2_WIN_AMOUNT = "PROGRESSIVE_2_WIN_AMOUNT",
    PROGRESSIVE_3_WIN_QUANTITY = "PROGRESSIVE_3_WIN_QUANTITY",
    PROGRESSIVE_3_WIN_AMOUNT = "PROGRESSIVE_3_WIN_AMOUNT",
    PROGRESSIVE_4_WIN_QUANTITY = "PROGRESSIVE_4_WIN_QUANTITY",
    PROGRESSIVE_4_WIN_AMOUNT = "PROGRESSIVE_4_WIN_AMOUNT",
    PROGRESSIVE_5_WIN_QUANTITY = "PROGRESSIVE_5_WIN_QUANTITY",
    PROGRESSIVE_5_WIN_AMOUNT = "PROGRESSIVE_5_WIN_AMOUNT",
    PROGRESSIVE_6_WIN_QUANTITY = "PROGRESSIVE_6_WIN_QUANTITY",
    PROGRESSIVE_6_WIN_AMOUNT = "PROGRESSIVE_6_WIN_AMOUNT",
    PROGRESSIVE_7_WIN_QUANTITY = "PROGRESSIVE_7_WIN_QUANTITY",
    PROGRESSIVE_7_WIN_AMOUNT = "PROGRESSIVE_7_WIN_AMOUNT",
    PROGRESSIVE_8_WIN_QUANTITY = "PROGRESSIVE_8_WIN_QUANTITY",
    PROGRESSIVE_8_WIN_AMOUNT = "PROGRESSIVE_8_WIN_AMOUNT",
    PROGRESSIVE_9_WIN_QUANTITY = "PROGRESSIVE_9_WIN_QUANTITY",
    PROGRESSIVE_9_WIN_AMOUNT = "PROGRESSIVE_9_WIN_AMOUNT",
    PROGRESSIVE_10_WIN_QUANTITY = "PROGRESSIVE_10_WIN_QUANTITY",
    PROGRESSIVE_10_WIN_AMOUNT = "PROGRESSIVE_10_WIN_AMOUNT",
    TOTAL_PROGRESSIVE_WIN_QUANTITY = "TOTAL_PROGRESSIVE_WIN_QUANTITY",
    TOTAL_PROGRESSIVE_WIN_AMOUNT = "TOTAL_PROGRESSIVE_WIN_AMOUNT",
    TOTAL_TICKETS_OUT_QUANTITY = "TOTAL_TICKETS_OUT_QUANTITY",
    PROMO_INITIAL_AMOUNT = "PROMO_INITIAL_AMOUNT",
    PROMO_LEFT_AMOUNT = "PROMO_LEFT_AMOUNT",
    PROMO_LEVEL_QUANTITY = "PROMO_LEVEL_QUANTITY",
    PROMO_LAST_BET_AMOUNT = "PROMO_LAST_BET_AMOUNT",
    PROMO_GAMES_PLAYED_QUANTITY = "PROMO_GAMES_PLAYED_QUANTITY",
    TIME_ON_DEVICE = "TIME_ON_DEVICE",
    TIME_ON_DEVICE_GAMES = "TIME_ON_DEVICE_GAMES",
    NONE = "NONE",
}

export enum MeterValueType {
    Quantity = "Quantity",
    Credits = "Credits",
    Cents = "Cents",
    Ratio = "Ratio",
    DurationMillis = "DurationMillis",
}

export interface SetSettingsResult {
    Path: string | undefined;
    Value: string | undefined;
    Success: boolean;
    Message: string | undefined;
}

export interface SystemInfo {
    AnydeskID: string | undefined;
    ZeroTierID: string | undefined;
    ZeroTierNetworks: string[] | undefined;
    Motherboard: Motherboard | undefined;
    Network: Network | undefined;
    IOBoard: IOBoard | undefined;
    BackendVersion: string | undefined;
    FrontendVersion: string | undefined;
    FakeBackendVersion: string | undefined;
    FakeFrontendVersion: string | undefined;
    PublicBackendVersion: string | undefined;
    PublicFrontendVersion: string | undefined;
    System: MySystem | undefined;
    Signatures: Signatures | undefined;
    CurrentSystemTime: string | undefined;
    SASLibVersion: string | undefined;
}

export interface Motherboard {
    Vendor: string | undefined;
    Model: string | undefined;
    Bios: Bios | undefined;
    CPU: CPU | undefined;
    RAM: RAM | undefined;
    Storage: StorageInfo | undefined;
}

export interface Bios {
    Info: string | undefined;
}

export interface CPU {
    Model: string | undefined;
    Info: string | undefined;
}

export interface RAM {
}

export interface StorageInfo {
}

export interface Network {
    Interfaces: { [key: string]: MyNetworkInterface; } | undefined;
}

export interface MyNetworkInterface {
    Operational: string | undefined;
    HardwareAddress: string | undefined;
    IPv4: string | undefined;
}

export interface IOBoard {
    Name: string | undefined;
    Platform: string | undefined;
    CommunicationOK: boolean;
    Serial: string | undefined;
    Version: string | undefined;
    Inputs: string | undefined;
    Outputs: string | undefined;
}

export interface MySystem {
    Version: string | undefined;
    Kernel: string | undefined;
    Chromium: string | undefined;
}

export interface Signatures {
    BackendCodeRead: string | undefined;
    BackendCodeCalc: string | undefined;
    BackendResRead: string | undefined;
    BackendResCalc: string | undefined;
    FrontendCodeRead: string | undefined;
    FrontendCodeCalc: string | undefined;
    FrontendResRead: string | undefined;
    FrontendResCalc: string | undefined;
}

export interface LinkLicenceStatus {
    IsValid: boolean;
    LinkLicence: LinkLicence | undefined;
    Hardware: Hardware | undefined;
    RequestCode: string | undefined;
}

export interface LinkLicence {
    Hardware: Hardware | undefined;
    Key: string | undefined;
    Signature: string | undefined;
    Request: string | undefined;
    Confirm: string | undefined;
}

export interface Hardware {
    IOConnected: boolean;
    IOSerial: string | undefined;
    MBSerial: string | undefined;
}

export interface TimeLicenceStatus {
    TimeLicence: TimeLicence | undefined;
    Hardware: Hardware | undefined;
    RequestCode: string | undefined;
}

export interface TimeLicence {
    expiryDate: Date;
    expiryDateDisplay: string | undefined;
    IsValid: boolean;
}

export interface HistoryGamePage {
    TotalGames: number;
    CurrentGame: number;
    HistoryGame: HistoryGame | undefined;
}

export interface HistoryGame {
    Id: number;
    Game: string | undefined;
    Math: string | undefined;
    StartDate: Date;
    StartDateFormatted: string | undefined;
    CreditStart: number;
    BetCredits: number;
    BetLines: number;
    BetDenom: number;
    Bet: number;
    BetType: BetType;
    BetBuyBonusCredits: number;
    TotalWin: number;
    CreditEnd: number;
    WasBonus: boolean;
    WasHandpay: boolean;
    HistoryGameStateId: number | undefined;
    HistoryGameState: HistoryGameState | undefined;
    Finished: boolean;
    FinishDate: Date | undefined;
    FinishDateFormatted: string | undefined;
    Reported: boolean;
    ReportedDate: Date | undefined;
}

export interface HistoryGameState {
    Id: number;
    GameState: string | undefined;
}

export enum OutputState {
    Off = "Off",
    On = "On",
    Blinking1 = "Blinking1",
    Blinking2 = "Blinking2",
}

export interface IOMappingFile {
    File: string | undefined;
    FileName: string | undefined;
    Name: string | undefined;
}

export interface PublicJackpotHitRequest {
    HitIndex: number;
    JackpotLevel: JackpotLevel;
    Amount: number;
}

export interface MachineLockedParams {
    LockEvents: PublicEvent[] | undefined;
}

export interface HandpayPendingParams {
    PendingHandpays: HandpayData[] | undefined;
}

export interface CashInParams {
    Cashin: Money | undefined;
    Current: Money | undefined;
}

export interface CashOutParams {
    Cashout: Money | undefined;
    Current: Money | undefined;
}

export interface JackpotValuesUpdateParams {
    JackpotValues: { [key in keyof typeof JackpotLevel]?: JackpotValue2; } | undefined;
}

export interface JackpotValue2 {
    JackpotLevel: JackpotLevel;
    CurrentValue: number;
    Multiplier: number;
    CurrentMultipliedValue: number;
    ResetValue: number;
    ResetMultipliedValue: number;
}

export interface LinkLicenceParams {
    LinkLicenceStatus: LinkLicenceStatus | undefined;
}

export interface TimeLicenceParams {
    TimeLicenceStatus: TimeLicenceStatus | undefined;
}

export enum InputState {
    RisingEdge = "RisingEdge",
    High = "High",
    FallingEdge = "FallingEdge",
    Low = "Low",
}

export interface SharedJackpotWin {
    JackpotLevel: JackpotLevel;
    WinAmount: Money | undefined;
    BetCents: Money | undefined;
    TotalBetCents: Money | undefined;
    TotalJackpotAmount: Money | undefined;
}

export interface SpinAndHoldCommonConfiguration {
    Trigger: IPublicSimpleBonusTrigger | undefined;
    MultiFeatureConfiguration: { [key: string]: IFeatureConfiguration; } | undefined;
    MultiReelSets: { [key: string]: PublicReel[]; } | undefined;
    CommonFeatureConfiguration: { [key: string]: IFeatureCommonConfiguration; } | undefined;
    MultiPlayWindow: PlayWindow[] | undefined;
    SymbolSpanSizes: SymbolSpanSize[] | undefined;
    Multipliers: number[] | undefined;
    TriggerCount: number;
    ResetSpinsCount: number;
}

export interface IPublicSimpleBonusTrigger {
    TriggerType: string | undefined;
    Count: number;
    BonusName: string | undefined;
    RequiredSymbols: number[];
    TriggerHintState: TriggerHintState[] | undefined;
}

export interface TriggerHintState {
    Bet: Money | undefined;
    Multiplier: number;
}

export interface PublicReel {
    Symbols: number[] | undefined;
    Name: string | undefined;
    Index: number;
    Col: number;
    Row: number;
    ColSpan: number;
    RowSpan: number;
    Height: number;
    StartPosition: number;
}

export interface IFeatureCommonConfiguration {
    FeatureType: string | undefined;
    FeatureName: string | undefined;
}

export interface PlayWindow {
    Width: number;
    Height: number;
    NumOfSymbols: number;
}

export interface SymbolSpanSize {
    RowSpan: number;
    ColSpan: number;
}

export interface BigSymbolFreegamesCommonConfiguration {
    PlayWindow: PlayWindow;
    SimpleBonusTriggers: IPublicSimpleBonusTrigger[] | undefined;
    FeatureConfigurations: IFeatureConfiguration[] | undefined;
    ReelSet: PublicReel[] | undefined;
    SymbolSpanSizes: SymbolSpanSize[] | undefined;
}

export interface ExtendedSpinAndHoldCommonConfiguration extends SpinAndHoldCommonConfiguration {
}

export interface FreegamesCommonConfiguration {
    PlayWindow: PlayWindow;
    StartingOptions: FreegamesOption[] | undefined;
    SimpleBonusTriggers: IPublicSimpleBonusTrigger[] | undefined;
    FeatureConfigurations: IFeatureConfiguration[] | undefined;
    ReelSet: number[][] | undefined;
}

export interface FreegamesOption {
    Symbols: number;
    StartingFreegames: number;
}

export interface MultiBonusCommonConfiguration extends ExtendedSpinAndHoldCommonConfiguration {
}

export interface ExpandingWildBulkConfiguration {
    FeatureType: string | undefined;
    FeatureName: string | undefined;
    Symbol: string | undefined;
}

export interface ExpandingWildReelConfiguration {
    FeatureType: string | undefined;
    FeatureName: string | undefined;
    Symbol: string | undefined;
}

export interface ScatterConfiguration {
    FeatureType: string | undefined;
    FeatureName: string | undefined;
    Symbols: string[] | undefined;
}

export interface ScatterClassicConfiguration {
    FeatureType: string | undefined;
    FeatureName: string | undefined;
    Symbols: string[] | undefined;
}

export interface ScatterRandomAwardConfiguration {
    FeatureType: string | undefined;
    FeatureName: string | undefined;
    RequiredSymbols: string[];
    FullCount: number;
    AvailableAwards: IAwardOption[] | undefined;
    MadeForBetCredits: number | undefined;
}

export interface IAwardOption {
    AwardType: AwardType;
    AwardIndex: number;
    AwardName: string | undefined;
}

export enum AwardType {
    Jackpot = "Jackpot",
    BetMultiplier = "BetMultiplier",
    Credit = "Credit",
}

export interface PlusOneFeatureConfiguration {
    FeatureType: string | undefined;
    FeatureName: string | undefined;
    RequiredSymbol: string | undefined;
    Value: number;
    MaxAdditionalFreegames: number;
}

export interface UnlockRowsConfig {
    Rows: UnlockRow[] | undefined;
    BaseCount: number;
    FeatureType: string | undefined;
    FeatureName: string | undefined;
    TopRow: number;
    BottomRow: number;
}

export interface UnlockRow {
    Index: number;
    Unlock: number;
}

export interface ExpandingWildBulkResult {
    Positions: Position[] | undefined;
    FeatureName: string | undefined;
    FeatureTriggered: boolean;
    Count: number;
}

export interface Position {
    reel: number;
    row: number;
}

export interface ExpandingWildReelResult {
    Positions: Position[] | undefined;
    FeatureName: string | undefined;
    FeatureTriggered: boolean;
    Count: number;
}

export interface ScatterResult {
    FeatureTriggered: boolean;
    RequiredSymbols: Symbol[] | undefined;
    PositionsPerSymbol: { [key: string]: ScatterWin; } | undefined;
    Count: number;
    FeatureName: string | undefined;
}

export interface Symbol {
    ID: string | undefined;
    SymbolType: SymbolType;
    Index: number;
    SymbolTypeStr: string | undefined;
    IsWild: boolean;
}

export enum SymbolType {
    Regular = "Regular",
    Wild = "Wild",
    Scatter = "Scatter",
    ScatterClassic = "ScatterClassic",
    MysteryWild = "MysteryWild",
    ExpandingWildBulk = "ExpandingWildBulk",
    ExpandingWildReel = "ExpandingWildReel",
    Special = "Special",
}

export interface ScatterWin {
    Symbol: number;
    SymbolID: string | undefined;
    Count: number;
    Win: Money | undefined;
    Position: Position[] | undefined;
}

export interface ScatterClassicResult {
    FeatureTriggered: boolean;
    RequiredSymbols: Symbol[] | undefined;
    PositionsPerSymbol: { [key: string]: ScatterWin; } | undefined;
    Count: number;
    FeatureName: string | undefined;
}

export interface ScatterRandomAwardResult {
    FeatureTriggered: boolean;
    ScattersAddedThisSpin: number;
    ScattersTotal: number;
    FullCountRequired: number;
    Count: number;
    ScatterColumnRow: IAwardOption[] | undefined;
    NumScattersPerReel: number[] | undefined;
    ScattersPosition: AwardOptionPosition[] | undefined;
    ScattersPositionThisSpin: AwardOptionPosition[] | undefined;
    FullAwardOption: IAwardOption | undefined;
    FullAward: Award | undefined;
    Awards: AwardPositionWithValue[] | undefined;
    FeatureName: string | undefined;
}

export interface AwardOptionPosition {
    Row: number;
    Col: number;
    Reel: number;
    ReelOffset: number;
    ReelPosition: number;
    RowSpan: number;
    ColSpan: number;
    AwardOption: IAwardOption | undefined;
}

export interface Award {
    AwardOption: IAwardOption | undefined;
    Value: Money | undefined;
}

export interface AwardPositionWithValue {
    Value: Money | undefined;
    AwardOptionPosition: AwardOptionPosition | undefined;
}

export interface PlusOneFeatureResult {
    AdditionalFreegames: number;
    SymbolPositions: SymbolPosition[] | undefined;
    FeatureTriggered: boolean;
    Count: number;
    FeatureName: string | undefined;
}

export interface UnlockRowsResult {
    Rows: UnlockRow[] | undefined;
    FeatureTriggered: boolean;
    Count: number;
    CountTotal: number;
    FeatureName: string | undefined;
}

export interface BetMultiplierAwardOption {
    AwardType: AwardType;
    AwardName: string | undefined;
    AwardIndex: number;
    BetMultiplier: number;
}

export interface CreditAwardOption {
    AwardType: AwardType;
    AwardName: string | undefined;
    AwardIndex: number;
    Credits: number;
    MadeForBetCredits: number;
}

export interface JackpotAwardOption {
    AwardType: AwardType;
    AwardName: string | undefined;
    AwardIndex: number;
    JackpotName: string | undefined;
    JackpotLevel: JackpotLevel;
}

export interface BasegameSpinAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    Spin: SlotGameSpin | undefined;
    SpinWithFeatures: SlotGameSpin | undefined;
    Triggers: SimpleTriggerResult[] | undefined;
    Win: SlotGameWin | undefined;
    AnticipationReel: number;
}

export interface DoubleUpCollectAllAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    UsedCards: Card[];
    History: Card[];
    Phase: SimpleBonusPhase;
    Depth: number;
    ForceGameEnd: boolean;
    PickSequence: number;
    Bet: Money | undefined;
    Collected: Money | undefined;
    TotalBet: Money | undefined;
    Credit: Money | undefined;
    CreditEnd: Money | undefined;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export interface DoubleUpCollectHalfAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    PickSequence: number;
    UsedCards: Card[];
    History: Card[];
    Phase: SimpleBonusPhase;
    Bet: Money | undefined;
    Collected: Money | undefined;
    TotalBet: Money | undefined;
    Credit: Money | undefined;
    CreditEnd: Money | undefined;
    Depth: number;
    ForceGameEnd: boolean;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export interface DoubleUpEndAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    PickSequence: number;
    History: Card[];
    Credit: Money | undefined;
    Bet: Money | undefined;
    Collected: Money | undefined;
    CreditEnd: Money | undefined;
    TotalBet: Money | undefined;
    BetStart: Money | undefined;
    ForceGameEnd: boolean;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export interface DoubleUpPickAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    PickSequence: number;
    PlayerSelectedColor: CardColor;
    RandomCard: Card;
    RandomCardColor: CardColor;
    Won: boolean;
    UsedCards: Card[];
    History: Card[];
    Phase: SimpleBonusPhase;
    Depth: number;
    Bet: Money | undefined;
    Collected: Money | undefined;
    TotalBet: Money | undefined;
    Credit: Money | undefined;
    CreditEnd: Money | undefined;
    ForceGameEnd: boolean;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export interface DoubleUpStartAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    PickSequence: number;
    History: Card[];
    Bet: Money | undefined;
    Collected: Money | undefined;
    TotalBet: Money | undefined;
    Credit: Money | undefined;
    CreditEnd: Money | undefined;
    ForceGameEnd: boolean;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export interface SpinAndHoldEndAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Multiplier: number;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
    FullAward: Award | undefined;
    Awards: AwardPositionWithValue[] | undefined;
}

export interface SpinAndHoldSpinAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Multiplier: number;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    Win: SlotGameWin | undefined;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
    SpinsRemaining: number;
    SpinsPlayed: number;
    SpinsAdditional: number;
    LimitingReel: number;
    HoldReels: number[] | undefined;
    SpinWithFeatures: SlotGameSpin | undefined;
    Triggers: SimpleTriggerResult[] | undefined;
}

export interface SpinAndHoldStartAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    PlayWindow: PlayWindow;
    ReelSetId: string | undefined;
    FeatureConfigurationIds: string[] | undefined;
    Types: MultiBonusType[];
    Multiplier: number;
    Win: SlotGameWin | undefined;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
    Depth: number;
    SpinsStarted: number;
    SpinsRemaining: number;
    LimitingReel: number;
    HoldReels: number[] | undefined;
    ReelStops: number[] | undefined;
    Spin: SlotGameSpin | undefined;
    SpinWithFeatures: SlotGameSpin | undefined;
    Triggers: SimpleTriggerResult[] | undefined;
}

export enum MultiBonusType {
    Double = "Double",
    Jackpot = "Jackpot",
    Multiplier = "Multiplier",
}

export interface ISpinAndHoldAction {
}

export interface BigSymbolFreegamesEndAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
}

export interface BigSymbolFreegamesSpinAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    SpinsStarted: number;
    SpinsPlayed: number;
    SpinsRemaining: number;
    SpinsAdditional: number;
    Spin: SlotGameSpin | undefined;
    SpinWithFeatures: SlotGameSpin | undefined;
    Anticipation: number;
    Triggers: SimpleTriggerResult[] | undefined;
    Win: SlotGameWin | undefined;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
}

export interface BigSymbolFreegamesStartAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    SpinsStarted: number;
    ReelStops: number[] | undefined;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export interface BigSymbolSpinAndHoldEndAction extends SpinAndHoldEndAction {
    Bonus: string | undefined;
    Action: string | undefined;
}

export interface BigSymbolSpinAndHoldSpinAction extends SpinAndHoldSpinAction {
    Bonus: string | undefined;
    Action: string | undefined;
}

export interface BigSymbolSpinAndHoldStartAction extends SpinAndHoldStartAction {
    Bonus: string | undefined;
    Action: string | undefined;
}

export interface ExtendedSpinAndHoldEndAction extends SpinAndHoldEndAction {
    Bonus: string | undefined;
    Action: string | undefined;
}

export interface ExtendedSpinAndHoldSpinAction extends SpinAndHoldSpinAction {
    Bonus: string | undefined;
    Action: string | undefined;
}

export interface ExtendedSpinAndHoldStartAction extends SpinAndHoldStartAction {
    Bonus: string | undefined;
    Action: string | undefined;
}

export interface FreegamesEndAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
}

export interface FreegamesSpinAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    SpinsStarted: number;
    SpinsPlayed: number;
    SpinsRemaining: number;
    SpinsAdditional: number;
    SpinWithFeatures: SlotGameSpin | undefined;
    Spin: SlotGameSpin | undefined;
    Anticipation: number;
    Triggers: SimpleTriggerResult[] | undefined;
    Win: SlotGameWin | undefined;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
}

export interface FreegamesStartAction {
    Bonus: string | undefined;
    Variant: string | undefined;
    Action: string | undefined;
    Phase: SimpleBonusPhase;
    Depth: number;
    SpinsStarted: number;
    ReelStops: number[] | undefined;
    WinAmounts: SimpleSlotGameWinAmounts | undefined;
    WinSinceGameStart: SimpleSlotGameWinAmounts | undefined;
    WinSinceBonusStart: SimpleSlotGameWinAmounts | undefined;
}

export interface MultiBonusEndAction extends ExtendedSpinAndHoldEndAction {
    Bonus: string;
    Action: string;
}

export interface MultiBonusSpinAction extends ExtendedSpinAndHoldSpinAction {
    Bonus: string;
    Action: string;
}

export interface MultiBonusStartAction extends ExtendedSpinAndHoldStartAction {
    Bonus: string;
    Action: string;
    Types: MultiBonusType[];
    PlayWindow: PlayWindow;
    ReelSetId: string;
    FeatureConfigurationIds: string[];
}

export interface SimpleSlotGameConfiguration {
    Name: string | undefined;
    Index: number;
    Order: number;
    Meta: SlotGameMeta | undefined;
    PlayWindow: PlayWindow;
    EnabledBets: BetConfig[] | undefined;
    Playlines: number[][] | undefined;
    Symbols: Symbol[] | undefined;
    Paytable: IPaytableData | undefined;
    ReelSet: number[][] | undefined;
    Feature: string[] | undefined;
    FeatureConfigurations: IFeatureConfiguration[] | undefined;
    BonusTriggers: IPublicSimpleBonusTrigger[] | undefined;
    BonusConfiguration: { [key: string]: ISimpleBonusCommonConfiguration; } | undefined;
    JackpotEnabled: boolean;
    AvailableJackpots: JackpotLevel[] | undefined;
    Setup: SimpleSlotGameSetup | undefined;
    GameType: GameType;
    GameName: string | undefined;
    GameIndex: number;
}

export interface SlotGameMeta {
    GameName: string | undefined;
    GameId: number;
    Demo: boolean;
    GameVersion: string | undefined;
    TargetRTP: number;
    SourceName: string | undefined;
    SourceMath: string | undefined;
    GeneratedDate: Date;
    SignedDate: Date;
    Signature: string | undefined;
    CalculatedSignature: string | undefined;
    onlineParams: OnlineParams | undefined;
    InterfaceVersion: string | undefined;
}

export interface OnlineParams {
    original: string | undefined;
    settings: string | undefined;
    serverid: string | undefined;
    Nojackpot: boolean;
    Currency: string | undefined;
}

export interface SimpleSlotGameSetup {
    NewSticker: NewSticker;
}

export interface DoubleUpConfiguration {
    GameType: GameType;
    GameName: string | undefined;
    GameIndex: number;
    MaxPicks: number;
    Order: number;
}

export interface HardwareSettingsEnumValue extends HardwareSettingsValue {
    AvailableValues: EnumItem[] | undefined;
}

export interface EnumItem {
    Value: string | undefined;
    Label: string | undefined;
}

export interface SimplePaytableData {
    Type: string | undefined;
    Pays: SimplePaytableRegularSymbol[] | undefined;
    Template: string | undefined;
    PaytableForBetCredits: number;
}

export interface SimplePaytableRegularSymbol {
    Symbol: Symbol | undefined;
    Combinations: SimplePaytableCombination[] | undefined;
    DictCombinations: { [key: string]: SimplePaytableCombination; } | undefined;
}

export interface SimplePaytableCombination {
    Count: number;
    WinCredits: number;
}

export interface GroupedSimplePaytableData {
    Type: string | undefined;
    Template: string | undefined;
    Groups: { [key in keyof typeof PaytableGroupName]?: SimplePaytableGroup; } | undefined;
    PaytableForBetCredits: number;
}

export enum PaytableGroupName {
    TopLeft = "TopLeft",
    MiddleLeft = "MiddleLeft",
    BottomLeft = "BottomLeft",
    TopCenter = "TopCenter",
    MiddleCenter = "MiddleCenter",
    BottomCenter = "BottomCenter",
    TopRight = "TopRight",
    MiddleRight = "MiddleRight",
    BottomRight = "BottomRight",
}

export interface SimplePaytableGroup {
    Name: PaytableGroupName;
    Pays: SimplePaytableCombination[] | undefined;
    Symbols: string[] | undefined;
    SymbolsIndexes: number[] | undefined;
}